import React, { useEffect, useState } from 'react';
import logoUrl from './welti-furrer-logo.svg';
import './WeltiTimelyLoader.css';

/** Verzögerung, unterhalb der kein Loader erscheint (Anti-Flicker). */
const SHOW_DELAY_MS = 250;

export const WeltiTimelyLoader: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="welti-loader" role="status" aria-live="polite" aria-label="Lädt">
      {visible && <img className="welti-loader-logo" src={logoUrl} alt="" />}
    </div>
  );
};

export default WeltiTimelyLoader;
